import { useMutation } from "react-query";
import http from "infra/http";

function useSaveConciliacaoBancaria() {
  return useMutation(
    (form: {
      tenantContaId: string;
      file: File;
     }) => {
      const formData = new FormData();

      formData.append('tenantContaId', form.tenantContaId);
      formData.append('file', form.file);

      return http.post(`/v1/extrato-bancario/ofx`, formData);
    },
    { retry: false }
  );
}

export default useSaveConciliacaoBancaria;
